<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col class="align-center">
        <v-card flat>
          <v-card-title primary-title class="justify-center">
            <div>
              <div class="headline">{{ lang.access_denied }}</div>
              <div><v-divider class="ma-0 pa-0"></v-divider></div>
              <span>
                <div class="subtitle-1" v-if="adminUser.accountDisabled">
                  {{ lang.account_disabled }}
                </div>
                <div class="subtitle-1" v-else>
                  {{ lang.access_denied_msg1 }}
                  <br />
                  {{ adminUser.email }}
                </div>
              </span>
            </div>
          </v-card-title>

          <v-card-actions class="justify-center">
            <v-btn depressed="" color="primary" @click="logout()">{{
              lang.access_denied_msg2
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

var fb;
export default {
  mounted() {},
  computed: {
    ...mapState(["adminUser", "lang"]),
  },

  data: () => ({
    sheet: true,
    sending: false,
  }),
  methods: {
    destroyed() {
      this.adminUser.logout();
    },
    logout: function() {
      this.adminUser.logout();
    },
  },
};
</script>
